import { render, staticRenderFns } from "./AccountForget.vue?vue&type=template&id=367f4d0f"
import script from "./AccountForget.vue?vue&type=script&lang=js"
export * from "./AccountForget.vue?vue&type=script&lang=js"
import style0 from "./AccountForget.vue?vue&type=style&index=0&id=367f4d0f&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports